import "core-js/modules/es6.function.name";
import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { baseUrl } from '@/config/index.js';
import { importTeacherFile } from '@data/teacher';
import { importStudentFile, importStudentInfoByFile, confirmImportStudent, dowLoadTest } from '@data/student';
import { importPersonFile } from '@data/person';
import { mapActions } from 'vuex';
export default {
  name: 'importPage',
  components: {},
  props: {
    configVo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formSubmitFlag: false,
      filename: '',
      errorList: [],
      files: [],
      importType: 'new',
      // 'new' | 'entrance' | 'merge'
      tipsObj: {
        newTips: '场景说明：系统中没有要导入的学生信息，全新导入学生信息并建立学生用户。',
        entranceTips: '场景说明：系统中存在要导入的学生信息，学生是由小学升入初中或初中升入高中的学生。',
        mergeTips: '场景说明：系统中存在要导入的学生信息，由于学校合并的原因，需要把学生信息转入新的学校。'
      },
      showConfirm: false,
      showBtn: true,
      // 是否显示导入按钮
      hasSuccess: false,
      // 是否全部导入成功
      showErrorList: false,
      // 是否显示错误列表
      showTableList: false,
      // 是否显示表格数据
      importResult: {
        totalNum: 0,
        // 学生总数
        updateNum: 0,
        // 升学/合校学生数
        failureNum: 0,
        // 有问题学生数
        newNum: 0,
        // 新生数
        errorMsgList: [],
        // 异常信息
        tableData: {
          data: [],
          headerList: []
        },
        studentList: [],
        transferList: []
      },
      // 导入结果
      propsMap: {
        年级: 'gradeName',
        班级: 'className',
        学籍号: 'sid',
        姓名: 'name',
        性别: 'sex',
        民族: 'nation',
        是否独生子女: 'isOnlyChild',
        是否住校: 'isResidence'
      },
      studentTableList: [],
      // 返回的表格数据
      studentTableCurrent: 1,
      studentTableTotal: 0,
      studentTablePageSize: 10
    };
  },
  methods: _objectSpread({}, mapActions('user', {
    setUserAlert: 'setUserAlert'
  }), {
    openDownHref: function openDownHref() {
      var str = '';

      if (this.configVo.type === 'teacher') {
        // 教师批量下载
        str = baseUrl + 'template/excelTemplate/down/教师基本信息表.xlsx';
        window.open(str, '_blank');
      } else if (this.configVo.type === 'student') {
        dowLoadTest().then(function (res) {
          console.log(res);
        }).catch(function (err) {
          console.log('导出失败！', err);
        });
      } else if (this.configVo.type === 'person') {
        str = baseUrl + 'template/excelTemplate/down/教育局人员基本信息表.xlsx';
        window.open(str, '_blank');
      }
    },
    fileChange: function fileChange(e) {
      this.errorList = [];
      this.files = e.target.files || e.dataTransfer.files;
      this.filename = this.files[0].name;
    },
    submitForm: function submitForm(e) {
      var _this2 = this;

      var self = this;
      e.preventDefault();

      if (!this.files.length) {
        this.$notify.info('请选择文件！');
        return;
      }

      self.formSubmitFlag = true;
      self.errorList = []; // 只要点击就清空

      var formData = new window.FormData(document.getElementById('importScoreForm'));

      if (this.configVo.type === 'teacher') {
        importTeacherFile(formData).then(function (res) {
          self.formSubmitFlag = false;

          _this2.setUserAlert({
            flag: true,
            type: 'success',
            text: _this2.msg.WARNING_86
          }); //                    self.$notify.success(res.message);

        }).catch(function (res) {
          self.formSubmitFlag = false;
          var errorList = res.data || [];
          var name = self.filename;
          self.errorList = errorList.map(function (item) {
            return {
              name: name,
              index: item.index,
              message: item.message
            };
          });
          document.getElementById('excelWrap').value = null;

          _this2.$nextTick(function () {
            document.getElementById('errorList').scrollIntoView();
          });
        });
      } else if (this.configVo.type === 'student') {
        if (this.importType === 'new') {
          formData.append('type', 1);
        }

        if (this.importType === 'entrance') {
          formData.append('type', 2);
        } // 重置studentTableList


        this.studentTableList = [];
        this.showBtn = true;
        this.hasSuccess = false;
        this.showErrorList = false;
        this.showTableList = false;
        importStudentInfoByFile(formData).then(function (res) {
          console.log(res);
          self.formSubmitFlag = false;
          _this2.importResult = res;

          if (_this2.importResult.errorMsgList.length > 0) {
            // 有错误优先显示错误
            _this2.showErrorList = true;
            _this2.showTableList = false;
          } else if (_this2.importResult.errorMsgList.length == 0 && _this2.importResult.tableData.data.length > 0) {
            // 没错误有表格数据
            _this2.showErrorList = false;
            _this2.showTableList = true;
          } // 生成分页数据


          if (res.tableData && res.tableData.data && res.tableData.data.length > 0) {
            if (res.tableData.data.length >= 10) {
              _this2.studentTableList = res.tableData.data.slice(0, 10);
            } else {
              _this2.studentTableList = res.tableData.data;
            }

            _this2.studentTableTotal = res.tableData.data.length;
          }

          _this2.showConfirm = true;
        }).catch(function (err) {
          self.formSubmitFlag = false;
        }); // importStudentFile(formData)
        //   .then((res) => {
        //     self.formSubmitFlag = false;
        //     this.setUserAlert({
        //       flag: true,
        //       type: 'success',
        //       text: this.msg.WARNING_86,
        //     });
        //   })
        //   .catch((res) => {
        //     self.formSubmitFlag = false;
        //     let errorList = res.data || [];
        //     let name = self.filename;
        //     self.errorList = errorList.map((item) => {
        //       return {
        //         name,
        //         index: item.index,
        //         message: item.message,
        //       };
        //     });
        //     document.getElementById('excelWrap').value = null;
        //     this.$nextTick(() => {
        //       document.getElementById('errorList').scrollIntoView();
        //     });
        //   });
      } else if (this.configVo.type === 'person') {
        importPersonFile(formData).then(function (res) {
          self.formSubmitFlag = false;

          _this2.setUserAlert({
            flag: true,
            type: 'success',
            text: _this2.msg.WARNING_86
          });
        }).catch(function (res) {
          self.formSubmitFlag = false;
          var errorList = res.data || [];
          var name = self.filename;
          self.errorList = errorList.map(function (item) {
            return {
              name: name,
              index: item.index,
              message: item.message
            };
          });
          document.getElementById('excelWrap').value = null;

          _this2.$nextTick(function () {
            document.getElementById('errorList').scrollIntoView();
          });
        });
      }
    },
    // 更改导入类型
    changeImportType: function changeImportType(type) {
      this.showConfirm = false;
      this.importType = type;
      this.files = [];
      this.filename = '';
      document.getElementById('excelWrap').value = null;
    },
    // 取消导入
    cancelImport: function cancelImport() {
      var _this = this;

      this.$alert('请在Excel中修正错误信息后再重新导入吧，加油！！！', '提示信息', {
        confirmButtonText: '知道了',
        customClass: 'message-layout',
        callback: function callback() {
          _this.files = [];
          _this.filename = '';
          _this.showConfirm = false;
          document.getElementById('excelWrap').value = null;
        }
      });
    },
    // 全部导入
    handleImportStudent: function handleImportStudent() {
      var _this = this;

      this.$confirm('确认本次导入的信息完全正确吗？正确请点击”确定“按钮，否则点击”取消“按钮。', '确认信息', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning',
        center: true
      }).then(function () {
        if (_this.importResult.studentList.length > 0) {
          confirmImportStudent({
            studentList: _this.importResult.studentList,
            transferList: _this.importResult.transferList
          }).then(function (res) {
            if (res.code == 200) {
              _this.hasSuccess = true;
              _this.showBtn = false;
              _this.showErrorList = false;
              _this.showTableList = false;
            } else {
              console.log(res);
            }
          }).catch(function (err) {
            console.log(err);
          });
        }
      }).catch(function () {});
    },
    // 页码更改
    pageNumChange: function pageNumChange(page) {
      var start = (page - 1) * this.studentTablePageSize;
      var end = start + this.studentTablePageSize;

      if (end >= this.importResult.tableData.data.length) {
        end = this.importResult.tableData.data.length;
      }

      this.studentTableList = this.importResult.tableData.data.slice(start, end);
    },
    // 新生人数点击
    newStudentClick: function newStudentClick() {
      if (this.importResult.tableData.data.length > 0) {
        this.showTableList = true;
        this.showErrorList = false;
      }
    },
    // 问题人数点击
    errorStudentClick: function errorStudentClick() {
      if (this.importResult.errorMsgList.length > 0) {
        this.showErrorList = true;
        this.showTableList = false;
      }
    }
  })
};